import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "react-router-dom";
import { router } from "./router";
import { AuthProvider } from "@/features/auth/context/AuthContext";
import { useAuth } from "@/features/auth/hooks/useAuth";
import { DemoProvider } from "@/features/demo/context/DemoContext";
import { ToastProvider } from "@/components/ui/ToastProvider";
import { ThemeProvider } from "@/lib/theme-context";
import { LoadingSpinner } from "@/components/ui/LoadingSpinner";
import { OfflineBanner } from "@/components/pwa/OfflineBanner";

import { ReloadPrompt } from "@/components/pwa/ReloadPrompt";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 2, // 2 minutes
      refetchOnWindowFocus: true,
    },
  },
});

function AppRouter() {
  const { isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <LoadingSpinner />
      </div>
    );
  }

  return <RouterProvider router={router} future={{ v7_startTransition: true }} />;
}

export function App() {
  return (
    <ThemeProvider>
      <ToastProvider>
        <DemoProvider>
          <QueryClientProvider client={queryClient}>
            <AuthProvider>
              <AppRouter />
            </AuthProvider>
          </QueryClientProvider>
        </DemoProvider>
        <OfflineBanner />

        <ReloadPrompt />
      </ToastProvider>
    </ThemeProvider>
  );
}

